__turbopack_context__.v({
  "tooltip__trigger__mob": "JKm_IG_tooltip__trigger__mob",
  "tooltip__trigger__web": "JKm_IG_tooltip__trigger__web",
  "tp": "JKm_IG_tp",
  "tp--highlight": "JKm_IG_tp--highlight",
  "tp__arrow--highlight": "JKm_IG_tp__arrow--highlight",
});
